module.exports = __webpack_public_path__ + "static/rifat-df0a1f00f0e157bd459b4d023832bdcd.png";